/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Accepted_TitleInputs */

const en_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite Code Confirmed!`)
};

const ar_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تأكيد رمز الدعوة!`)
};

const de_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungscode bestätigt!`)
};

const es_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Código de invitación confirmado!`)
};

const fr_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d’invitation confirmé !`)
};

const it_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice invito confermato!`)
};

const ja_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードが確認されました！`)
};

const ko_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드가 확인됐어요!`)
};

const pt_br_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de convite confirmado!`)
};

const ru_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код приглашения подтвержден!`)
};

const th_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันรหัสเชิญแล้ว!`)
};

const tr_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodu onaylandı!`)
};

const zh_cn_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码已确认！`)
};

const zh_tw_invite_accepted_title = /** @type {(inputs: Invite_Accepted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請碼已確認！`)
};

/**
* | output |
* | --- |
* | "Invite Code Confirmed!" |
*
* @param {Invite_Accepted_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_accepted_title = /** @type {((inputs?: Invite_Accepted_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Accepted_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_accepted_title(inputs)
	if (locale === "ar") return ar_invite_accepted_title(inputs)
	if (locale === "de") return de_invite_accepted_title(inputs)
	if (locale === "es") return es_invite_accepted_title(inputs)
	if (locale === "fr") return fr_invite_accepted_title(inputs)
	if (locale === "it") return it_invite_accepted_title(inputs)
	if (locale === "ja") return ja_invite_accepted_title(inputs)
	if (locale === "ko") return ko_invite_accepted_title(inputs)
	if (locale === "pt_br") return pt_br_invite_accepted_title(inputs)
	if (locale === "ru") return ru_invite_accepted_title(inputs)
	if (locale === "th") return th_invite_accepted_title(inputs)
	if (locale === "tr") return tr_invite_accepted_title(inputs)
	if (locale === "zh_cn") return zh_cn_invite_accepted_title(inputs)
	return zh_tw_invite_accepted_title(inputs)
});